import { APICreate } from './API';

export const API = new APICreate();
